import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import { ReactSVG } from 'react-svg';
import { back_icon, upload_icon } from 'asset/icons';
import { fontSizes } from 'appconstants';
import InputField from 'components/InputField';
import ManageCustomerFunctional from './index.function'
import { CustomTable } from './component';
import { Button } from 'components/ui/button';
import { useLocation } from 'react-router-dom';
import { Formik } from 'formik';
import { customer_validation_schema } from 'validation_schema/customer_validation_schema';
import ErrorText from 'components/ErrorText';

const ManageCustomer = () => {
    const { state } = useLocation();
    const mode = state?.mode || 'create';
    const data = state?.customer ?? {};

    const {
        navigate,
        onPressCreate,
        fileInputRef,
        handleImageChange,
        common_loading
    } = ManageCustomerFunctional({ data, mode })

    return (
        <Wrapper className='flex flex-col h-screen'>


            {/* Header */}
            <div className='flex items-center gap-3 mb-6'>
                <div
                    onClick={() => navigate(-1)}
                    className='h-10 w-10 cursor-pointer rounded-md flex items-center justify-center bg-muted hover:bg-muted/50 transition'
                >
                    <ReactSVG src={back_icon} />
                </div>
                <div>
                    <Text text={mode === 'edit' ? 'Edit Customer' : 'Create Customer'} className='font-bold' size={fontSizes.h26} />
                    <Text text={`Fill in the details to ${mode === 'edit' ? "edit an existing" : "create a new"} Customer`} className='text-muted-foreground' />
                </div>
            </div>

            <Formik
                initialValues={{
                    name: data?.customerName ?? "",
                    address: data?.address ?? "",
                    rooms: data?.rooms ?? [],
                    stores: data?.stores ?? [],
                    logo: data?.logo ?? null,
                }}
                validationSchema={customer_validation_schema}
                onSubmit={(values: CreateCustomerSchema) => onPressCreate(values)}
            >
                {({ values, setFieldValue, handleSubmit, errors, handleChange }) => {

                    return (
                        <>
                            {/* Form Section */}
                            <div className='mt-5 rounded-xl border bg-white p-5 shadow-md '>
                                <div className='grid grid-cols-2 gap-4' >
                                    <div>
                                        <InputField
                                            label='Customer Name'
                                            required
                                            value={values?.name}
                                            placeholder={'Enter Customer Name'}
                                            onChange={handleChange("name")}
                                        />
                                        <ErrorText text={typeof errors?.name === 'string' ? errors?.name : ""} />
                                    </div>
                                    <div>
                                        <InputField
                                            label='Address'
                                            required
                                            value={values?.address}
                                            placeholder={'Enter Address'}
                                            onChange={handleChange("address")}
                                        />
                                        <ErrorText text={typeof errors?.address === 'string' ? errors?.address : ""} />
                                    </div>
                                </div>

                                <div className='mt-5 grid grid-cols-2 gap-6'>
                                    <div className='flex flex-col'>
                                        <Text text={'Customer Logo'} className='mb-2' />

                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            className="hidden"
                                            accept="image/*"
                                            onChange={(e) => handleImageChange(e, setFieldValue)}
                                        />

                                        <div
                                            onClick={() => fileInputRef.current.click()}
                                            className="h-32 w-full border-2 border-dashed border-[#84A544] rounded-xl flex flex-col items-center justify-center cursor-pointer transition-all"
                                        >
                                            {values.logo ? (
                                                <img
                                                    src={values.logo?.includes("data:image/png;base64") ? values?.logo : `${process.env.REACT_APP_IMAGE_URL}${values?.logo}`}
                                                    alt="Logo Preview"
                                                    className="h-full w-full object-contain p-2"
                                                />
                                            ) : (
                                                <div className='flex flex-col items-center gap-5'>
                                                    <ReactSVG src={upload_icon} />
                                                    <Text text="Upload Picture" className="text-primary font-bold" size={fontSizes.h16} />
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="hidden md:block"></div>
                                </div>

                                <div className="mt-5 grid grid-cols-1 lg:grid-cols-2 gap-4">
                                    <CustomTable setFieldValue={setFieldValue} array={values?.rooms} />

                                    <CustomTable setFieldValue={setFieldValue} isStore array={values?.stores} />
                                </div>

                                <Button disabled={common_loading} onClick={() => handleSubmit()} className='mt-10 w-52'>
                                    {mode === 'edit' ? 'Save' : 'Create'}
                                </Button>

                            </div>
                        </>
                    )
                }}
            </Formik>

        </Wrapper>
    );
};

export default ManageCustomer;
